import { Component, OnInit } from '@angular/core';
import { AdminConfigService } from 'src/app/services/admin-config/admin-config.service';

@Component({
  selector: 'app-admin-stripe',
  templateUrl: './admin-stripe.component.html',
  styleUrls: ['./admin-stripe.component.scss']
})
export class AdminStripeComponent implements OnInit {

  currentMode = 'test';
  cargando = false;
  cambiando = false;
  mensaje: string | null = null;
  error: string | null = null;

  constructor(private adminConfig: AdminConfigService) {}

  ngOnInit(): void {
    this.cargarConfig();
  }

  cargarConfig(): void {
    this.cargando = true;
    this.error = null;
    this.adminConfig.get().subscribe({
      next: (res: any) => {
        const data = res?.data ?? res;
        this.currentMode = data.stripeMode || 'test';
        this.cargando = false;
      },
      error: (err: any) => {
        this.error = 'Error al cargar configuracion: ' + (err.error?.message || err.message);
        this.cargando = false;
      }
    });
  }

  toggleMode(): void {
    const nuevoModo = this.currentMode === 'live' ? 'test' : 'live';
    this.cambiando = true;
    this.mensaje = null;
    this.error = null;

    this.adminConfig.save({ stripeMode: nuevoModo } as any).subscribe({
      next: () => {
        this.currentMode = nuevoModo;
        this.mensaje = 'Modo cambiado a ' + nuevoModo.toUpperCase() + ' exitosamente';
        this.cambiando = false;
      },
      error: (err: any) => {
        this.error = 'Error al cambiar modo: ' + (err.error?.message || err.message);
        this.cambiando = false;
      }
    });
  }
}
